import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { Union } from 'src/app/agent/agent-interface.service';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-free-milk',
  templateUrl: './free-milk.component.html',
  styleUrls: ['./free-milk.component.scss']
})
export class FreeMilkComponent implements OnInit {

  title = 'Free Milk';
  start_date: Date | null = null; // Start Date
  end_date: Date | null = null;   // End Date
  is_document_available: boolean = true; // Show/hide spinner
  document_file: any = null; // Store document data
  color: ThemePalette = 'primary'; // Spinner color
  mode: ProgressSpinnerMode = 'indeterminate'; // Spinner mode
  customer_type_list: any[] = []; // List of customer types
  selected_customer_types_id: number[] = []; // Selected customer types
  unions: Union[];
  selectedprodtId: any;
  selectedUnionId: any
  selectedcustomertypeunionId:any


  productname = [
    { id: 1, name: 'Tonned TM 500' },
    { id: 4, name: 'FCM FCM 500' },
    { id: 36, name: 'COW COW 500' },
    { id: 39, name: 'COW COW 200' }
  ];
  customerunion: any[];


  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;

    // Fetch customer types
    this.httpService.getCustomerType().subscribe(
      (customer_type_list: any[]) => {
        console.log(customer_type_list);
        this.customer_type_list = customer_type_list;
      },
      (error) => {
        console.error(error);
      }
    );

    this.httpService.getcustomerunion().subscribe(
      (customerunion: any[]) => {
        console.info(customerunion);
        this.customerunion = customerunion;
      },
      (error) => {
        console.error(error);
      }
    );

    
    this.getUnions();
  }

  // Fetch data when "Get" button is clicked
  getClicked() {
    if (this.start_date && this.end_date) {
      const data_dict = {
        start_date: this.start_date,
        end_date: this.end_date,
        customer_type_id: this.selected_customer_types_id,
        product_ids:this.selectedprodtId,
        union_ids:this.selectedUnionId
      };

      this.is_document_available = false;
      this.httpService.serveFreeMilkReport(data_dict).subscribe(
        (data) => {
          console.info('Response:', data);
          this.document_file = data;
          this.is_document_available = true;
          this.resetForm();

        },
        (error) => {
          console.error(error);
          this.is_document_available = true;
        }
      );
    } else {
      console.error('Start date or End date is not selected.');
    }
  }

  // Download the generated report
  downloadClicked() {
    const linkSource = 'data:application/excel;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement('a');
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    this.resetForm();

  }

  resetForm() {
    this.start_date = null;
    this.end_date = null;
    this.selected_customer_types_id = [];
    this.selectedprodtId = [];
    this.selectedUnionId = [];
  }

  // Update the minimum selectable date for "End Date"
  updateEndDateOptions() {
    if (this.start_date) {
      this.end_date = null; // Reset end_date if start_date changes
    }
  }

   getUnions() {
      this.httpService.getUnions().subscribe((data: Union[]) => {
        console.log(data);
        this.unions = data;
      }, (error) => {
        console.log(error);
      });
    }

  ngOnInit() {}
}
